import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  HostListener,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { SubmitButtonShared } from 'src/app/presentation/general/shared/submit-button-shared';
import { GenerateShared } from 'src/app/presentation/general/shared/generate-shared';

@Component({
  selector: 'app-start-date',
  templateUrl: './start-date.component.html',
  styleUrls: ['./start-date.component.scss'],
})
export class StartDateComponent implements OnInit, OnDestroy {
  @Input() isDetail = false;
  @Input() pageNumber: number;
  @Input() currentPageNumber: number;

  SWIPE_ACTION = { UP: 'swipeup', DOWN: 'swipedown' };
  startDay = 1;
  elementTop = 116;
  startDays: string[] = [
    'امروز',
    'فردا',
    'پس‌فردا',
    '۳ روز بعد',
    '۴ روز بعد',
    '۵ روز بعد',
    '۶ روز بعد',
  ];
  days = ['یکشنبه', 'دوشنبه', 'سه‌شنبه', 'چهارشنبه', 'پنجشنبه', 'جمعه', 'شنبه'];

  subscription: Subscription;

  constructor(
    private submitButtonShared: SubmitButtonShared,
    private generateShared: GenerateShared
  ) {
    const day = new Date();
    day.setDate(day.getDate() + 3);
    for (let d = 0; d < 4; d++) {
      this.startDays[d + 3] = this.days[day.getDay()];
      day.setDate(day.getDate() + 1);
    }
    this.generateShared.startDays = this.startDays;
    this.subscription = this.submitButtonShared.nextButtonClickObs$.subscribe(
      (clicked) => {
        if (clicked && this.pageNumber === this.currentPageNumber) {
          if (this.isDetail) {
            this.generateShared.startDay = this.startDay;
            this.generateShared.closeOverviewDetail();
          } else {
            this.generateShared.startDay = this.startDay;
            this.generateShared.nextPage();
          }
          //  console.log('stardday', this.generateShared.startDay)
        }
      }
    );
  }

  ngOnInit() {
    if (this.isDetail) {
      this.startDay = this.generateShared.startDay;
      this.elementTop -= (this.startDay - 1) * 50;
      document.getElementById('holder').style.top =
        this.elementTop.toString() + 'px';
    }
  }

  @HostListener('window:beforeunload')
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  swipe(action: string = this.SWIPE_ACTION.DOWN, data) {
    console.log(data);

    // next
    if (action === this.SWIPE_ACTION.DOWN) {
      this.previousDay(data.velocity);
    }

    // previous
    if (action === this.SWIPE_ACTION.UP) {
      this.nextDay(data.velocity);
    }
  }

  nextDay(velocity: number) {
    velocity = Math.ceil(velocity < 0 ? -1 * velocity : velocity);
    if (velocity <= 6) {
      if (this.startDay + velocity <= 6) {
        this.startDay += velocity;
      } else {
        this.startDay = 6;
      }
      this.elementTop =
        166 - 55 * this.startDay + this.startDay * this.startDay - 1;
      document.getElementById('holder').style.top =
        this.elementTop.toString() + 'px';
    } else {
      this.startDay = 6;
      this.elementTop =
        166 - 55 * this.startDay + this.startDay * this.startDay - 1;
      document.getElementById('holder').style.top =
        this.elementTop.toString() + 'px';
    }
  }

  previousDay(velocity: number) {
    velocity = Math.ceil((velocity < 0 ? -1 * velocity : velocity) * 2);

    if (this.startDay > 0) {
      if (this.startDay - velocity > 0) {
        this.startDay -= velocity;
      } else {
        this.startDay = 0;
      }
      this.elementTop =
        166 - 55 * this.startDay + this.startDay * this.startDay - 1;
      document.getElementById('holder').style.top =
        this.elementTop.toString() + 'px';
    }
  }
}
